<template>
  <div class="footer">
      <div class="center">
          <a class="a" target="_blank" href="Ï">
              <p class="p1">Contact Us:</p>
              <p class="p2"></p>
              <p class="p3">ericlee99@nwsuaf.edu.cn</p>
          </a>
          <p class="p4"><a target="_blank" href="https://beian.miit.gov.cn/">粤ICP备xxxxxxxx号-1</a></p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'LabFooter',
  data () {
    return {
      footerHeight: '',
      curWidth: '',
      logo_url: require('../../assets/img/logo/logo_color.png'),
      logo_url2: require('../../assets/img/logo/logo_white_font.png'),
      contact_way: [
        {
          name: '媒体问询',
          email: 'aerowangue@126.com'
        },
        {
          name: '招聘相关',
          email: 'aerowangue@126.com'
        },
        {
          name: '商务合作',
          email: 'aerowangue@126.com'
        },
        {
          name: '广告相关',
          email: 'aerowangue@126.com'
        }
      ],
      focus_icon: [
        {
          name: 'weibo',
          path: require('../../assets/img/focus/weibo.png'),
          qr: require('../../assets/img/focus/qr_weibo.png'),
          info: '关注官方微博'
        },
        {
          name: 'weixin',
          path: require('../../assets/img/focus/weixin.svg'),
          qr: require('../../assets/img/focus/qr_weixin.png'),
          info: '关注官方微信公众号'
        },
        {
          name: 'bilibili',
          path: require('../../assets/img/focus/bilibili.png'),
          qr: require('../../assets/img/focus/qr_bilibili.png'),
          info: '关注官方 bilibili 号'
        }
      ]
    }
  },
  methods: {
    // setFooterHeight () {
    //   this.curWidth = window.innerWidth
    //   if (this.curWidth <= 991) {
    //     this.footerHeight = 570 + 'px'
    //   } else {
    //     this.footerHeight = 280 + 'px'
    //   }
    // }
  },
  created () {
    // 页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    // window.addEventListener('resize', this.setFooterHeight)
    // this.setFooterHeight()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/public/LabFooter.vue